import { twMerge } from "tailwind-merge";
import { Link } from "react-router-dom";
import { Avatar } from "@shared/ui/Avatar";
import { Button } from "@shared/ui/Button";
import { Dropdown } from "@shared/ui/Dropdown";
import { Type } from "@shared/ui/Type";

export type Props = {
  className?: string;
  photo: string;
  fullName: string;
  isLoaded: boolean;
  onNavigationClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    to: string
  ) => void;
  menuItems: {
    title: string;
    href: string;
  }[];
};

export function PlatformAvatarDropdown({
  className,
  photo,
  fullName,
  isLoaded = false,
  onNavigationClick,
  menuItems,
}: Props) {
  return (
    <Dropdown
      trigger={
        <button
          className={twMerge(
            "flex items-center with-ring focus:rounded-lg",
            className
          )}
        >
          <Avatar
            image={photo}
            size={36}
            alt={fullName}
            isLoading={!isLoaded}
            className="cursor-pointer hover:bg-brand-900 text-brand-50"
          />
          <Type variant="h5" className="ml-4 md:hidden">
            {fullName}
          </Type>
        </button>
      }
    >
      <div className="flex items-center px-4 py-4 border-b">
        <Avatar
          image={photo}
          size={36}
          alt={fullName}
          isLoading={!isLoaded}
          className="cursor-pointer hover:bg-brand-900 text-brand-50"
        />
        <Type variant="h5" className="ml-4">
          {fullName}
        </Type>
      </div>

      <div className="flex flex-col gap-0">
        {menuItems.map((item) => (
          <Button
            key={item.title}
            as={Link}
            to={item.href}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
              onNavigationClick(e, item.href)
            }
            variant="menu-item"
            className="justify-start w-full"
            data-testid={`dashboard-nav-${item.title}`}
            title={item.title}
            aria-label={item.title}
          >
            {item.title}
          </Button>
        ))}
      </div>
    </Dropdown>
  );
}

export default PlatformAvatarDropdown;
